var _rect, _path, _path2, _path3, _g, _path4, _path5, _path6, _g2, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBackgroundLanding(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1266,
    height: 1150,
    viewBox: "0 0 1266 1150",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_828_3880",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 1266,
    height: 1150
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 1266,
    height: 1150,
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_828_3880)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.36
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask1_828_3880",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: -359,
    y: 292,
    width: 1530,
    height: 951
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1170.55 812.392L160.692 1242.3L-358.04 1102.06L228.639 304.393L789.595 292.578L1170.55 812.392Z",
    fill: "black"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_828_3880)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask2_828_3880",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: -427,
    y: 189,
    width: 1663,
    height: 1249
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M-426.514 347.746L-58.6147 1437.87L1235.87 923.538C1200.44 679.543 1127.43 191.161 1118.78 189.596C1110.14 188.031 84.9848 294.377 -426.514 347.746Z",
    fill: "url(#paint0_linear_828_3880)"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_828_3880)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask3_828_3880",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: -297,
    y: 63,
    width: 1545,
    height: 1152
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M-103.9 1214.8C-186.248 897.587 -291.223 492.905 -296.775 477.55L1054.92 63.9724L1247.79 801.223L-103.9 1214.8Z",
    fill: "url(#paint1_linear_828_3880)"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask3_828_3880)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M331.803 417.439C437.939 384.965 556.878 471.204 583.509 572.997C610.139 674.79 602.123 821.521 488.249 856.363C431.819 873.629 381.104 962.639 300.799 932.462C219.051 901.742 198.249 758.161 184.815 706.811C158.185 605.018 225.668 449.914 331.803 417.439Z",
    fill: "#FFABD3",
    fillOpacity: 0.48
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_828_3880)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M331.937 419.264C453.893 381.949 574.146 481.278 603.707 594.27C633.267 707.261 626.046 869.622 504.09 906.936C443.655 925.428 390.804 1026.35 304.282 992.052C216.205 957.138 192.508 797.946 177.597 740.947C148.037 627.955 209.981 456.579 331.937 419.264Z",
    fill: "#FFABD3",
    fillOpacity: 0.48
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_f_828_3880)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M340.327 435.14C382.784 373.933 619.455 478.93 647.511 586.171C675.567 693.412 657.884 850.823 513.431 895.021C441.848 916.924 377.03 1027.98 278.011 1000.6C177.214 972.729 156.262 811.371 142.11 757.273C114.054 650.031 245.047 406.01 340.327 435.14Z",
    fill: "#FFABD3",
    fillOpacity: 0.48
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_f_828_3880)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M365.262 473.424C529.346 450.347 694.563 543.235 725.916 663.078C757.268 782.92 711.215 936.937 558.21 983.752C482.388 1006.95 419.089 1167.39 313.394 1135.27C205.801 1102.58 183.891 932.749 168.075 872.295C136.723 752.452 175.179 500.158 365.262 473.424Z",
    fill: "#FFABD3",
    fillOpacity: 0.48
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_f_828_3880)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M450.16 450.209C570.425 469.079 849.648 549.337 881.941 672.775C914.234 796.214 522.175 1002.36 357.429 1052.77C275.789 1077.75 188.987 1155.18 75.9105 1123.39C-39.1972 1091.03 31.3483 902.955 82.5319 742.384C150.5 529.158 316.927 386.225 450.16 450.209Z",
    fill: "#FFABD3",
    fillOpacity: 0.48
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter4_f_828_3880)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M352.138 515.815C522.388 463.723 917.576 622.828 950.605 749.081C983.635 875.334 676.772 1027.47 506.522 1079.56C422.154 1105.37 222.493 1275.45 105.809 1243.25C-12.9702 1210.46 18.5999 1096.55 1.93815 1032.86C-31.0913 906.605 181.887 567.906 352.138 515.815Z",
    fill: "#FFABD3",
    fillOpacity: 0.48
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter5_f_828_3880)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M352.138 515.815C522.388 463.723 917.576 622.828 950.605 749.081C983.635 875.334 676.772 1027.47 506.522 1079.56C422.154 1105.37 222.493 1275.45 105.809 1243.25C-12.9702 1210.46 18.5999 1096.55 1.93815 1032.86C-31.0913 906.605 181.887 567.906 352.138 515.815Z",
    fill: "#FFABD3",
    fillOpacity: 0.48
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter6_f_828_3880)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M352.138 515.815C522.388 463.723 917.576 622.828 950.605 749.081C983.635 875.334 676.772 1027.47 506.522 1079.56C422.154 1105.37 222.493 1275.45 105.809 1243.25C-12.9702 1210.46 18.5999 1096.55 1.93815 1032.86C-31.0913 906.605 181.887 567.906 352.138 515.815Z",
    fill: "#FFABD3",
    fillOpacity: 0.48
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter7_f_828_3880)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M352.138 515.815C522.388 463.723 917.576 622.828 950.605 749.081C983.635 875.334 676.772 1027.47 506.522 1079.56C422.154 1105.37 222.493 1275.45 105.809 1243.25C-12.9702 1210.46 18.5999 1096.55 1.93815 1032.86C-31.0913 906.605 181.887 567.906 352.138 515.815Z",
    fill: "#FFABD3",
    fillOpacity: 0.48
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter8_f_828_3880)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M334.97 418.337C483.939 372.757 655.711 499.891 688.74 626.144C721.77 752.396 679.639 912.699 530.67 958.279C456.848 980.866 349.284 1047.6 245.13 1011.56C139.105 974.881 136.583 826.184 119.921 762.495C86.8916 636.242 186.001 463.917 334.97 418.337Z",
    fill: "#FFABD3",
    fillOpacity: 0.48
  })))))), /*#__PURE__*/React.createElement("mask", {
    id: "mask4_828_3880",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: -3,
    y: -110,
    width: 1649,
    height: 895
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M-2.48112 293.652L1064.5 -109.291L1646 24.002L1076.86 774.452L463.155 784.361L-2.48112 293.652Z",
    fill: "black"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask4_828_3880)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask5_828_3880",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: -85,
    y: -294,
    width: 1876,
    height: 1175
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M1790.87 735.033L1286.74 -293.114L-84.3645 188.772C-22.9492 418.792 102.285 879.205 111.901 880.699C121.518 882.193 1235.22 784.211 1790.87 735.033Z",
    fill: "url(#paint2_linear_828_3880)"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask5_828_3880)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask6_828_3880",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: -87,
    y: -83,
    width: 1753,
    height: 1153
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M1357.03 -82.793C1488.87 246.715 1656.97 667.08 1665.09 683.075L221.947 1069.88L-86.1121 304.013L1357.03 -82.793Z",
    fill: "url(#paint3_linear_828_3880)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask6_828_3880)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M977.026 726.629C863.711 757.001 720.994 664.587 678.46 558.843C635.926 453.099 625.978 302.034 747.556 269.447C807.804 253.299 852.523 163.005 945.284 196.477C1039.71 230.552 1081.15 379.215 1102.61 432.558C1145.14 538.302 1090.34 696.257 977.026 726.629Z",
    fill: "#81B3FF",
    fillOpacity: 0.48
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter9_f_828_3880)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M976.642 724.742C846.435 759.641 700.586 653.692 653.373 536.314C606.159 418.937 593.326 251.732 723.533 216.833C788.057 199.538 833.612 97.0231 933.783 134.927C1035.75 173.513 1082.4 338.358 1106.22 397.569C1153.43 514.947 1106.85 689.842 976.642 724.742Z",
    fill: "#81B3FF",
    fillOpacity: 0.48
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter10_f_828_3880)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M965.321 708.128C926.176 769.996 650.737 654.786 605.926 543.382C561.115 431.978 560.498 270.184 714.723 228.847C791.15 208.363 848.651 95.7444 961.767 126.884C1076.91 158.583 1120.8 325.58 1143.41 381.778C1188.22 493.182 1074.52 740.96 965.321 708.128Z",
    fill: "#81B3FF",
    fillOpacity: 0.48
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter11_f_828_3880)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M932.812 667.914C754.147 686.897 559.353 586.269 509.277 461.775C459.201 337.281 490.422 179.818 653.778 136.033C734.729 114.336 784.216 -49.2413 905.329 -13.0242C1028.62 23.8436 1074.65 199.605 1099.91 262.406C1149.99 386.901 1139.79 645.924 932.812 667.914Z",
    fill: "#81B3FF",
    fillOpacity: 0.48
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter12_f_828_3880)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M841.813 689.362C706.271 666.376 386.905 575.429 335.327 447.199C283.748 318.969 691.276 117.905 867.168 70.761C954.331 47.3986 1040.48 -29.9049 1169.72 6.19429C1301.29 42.942 1247.32 234.803 1211.26 398.873C1163.38 616.745 997.496 759.247 841.813 689.362Z",
    fill: "#81B3FF",
    fillOpacity: 0.48
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter13_f_828_3880)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M941.9 624.59C760.132 673.31 302.29 497.658 249.536 366.504C196.781 235.351 516.933 87.4825 698.702 38.7631C788.777 14.6202 987.967 -154.896 1121.25 -118.268C1256.94 -80.9821 1236.6 35.5583 1263.22 101.719C1315.97 232.872 1123.67 575.871 941.9 624.59Z",
    fill: "#81B3FF",
    fillOpacity: 0.48
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter14_f_828_3880)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M941.9 624.59C760.132 673.31 302.29 497.658 249.536 366.504C196.781 235.351 516.933 87.4825 698.702 38.7631C788.777 14.6202 987.967 -154.896 1121.25 -118.268C1256.94 -80.9821 1236.6 35.5583 1263.22 101.719C1315.97 232.872 1123.67 575.871 941.9 624.59Z",
    fill: "#81B3FF",
    fillOpacity: 0.48
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter15_f_828_3880)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M941.9 624.59C760.132 673.31 302.29 497.658 249.536 366.504C196.781 235.351 516.933 87.4825 698.702 38.7631C788.777 14.6202 987.967 -154.896 1121.25 -118.268C1256.94 -80.9821 1236.6 35.5583 1263.22 101.719C1315.97 232.872 1123.67 575.871 941.9 624.59Z",
    fill: "#81B3FF",
    fillOpacity: 0.48
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter16_f_828_3880)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M941.9 624.59C760.132 673.31 302.29 497.658 249.536 366.504C196.781 235.351 516.933 87.4825 698.702 38.7631C788.777 14.6202 987.967 -154.896 1121.25 -118.268C1256.94 -80.9821 1236.6 35.5583 1263.22 101.719C1315.97 232.872 1123.67 575.871 941.9 624.59Z",
    fill: "#81B3FF",
    fillOpacity: 0.48
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter17_f_828_3880)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M925.124 700.444C766.076 743.073 559.635 606.941 506.88 475.788C454.126 344.634 480.199 180.576 639.246 137.946C718.062 116.821 828.565 51.1645 948.475 91.3778C1070.54 132.314 1092.4 285.715 1119.02 351.876C1171.77 483.029 1084.17 657.814 925.124 700.444Z",
    fill: "#81B3FF",
    fillOpacity: 0.48
  })))))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_828_3880",
    x: 166.879,
    y: 407.859,
    width: 454.816,
    height: 594.666,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.70839,
    result: "effect1_foregroundBlur_828_3880"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_f_828_3880",
    x: 126.293,
    y: 405.08,
    width: 544.376,
    height: 611.794,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5.97937,
    result: "effect1_foregroundBlur_828_3880"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_f_828_3880",
    x: 141.211,
    y: 452.803,
    width: 611.081,
    height: 703.787,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 8.54197,
    result: "effect1_foregroundBlur_828_3880"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_f_828_3880",
    x: -32.3551,
    y: 388.696,
    width: 962.303,
    height: 788.365,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 23.0633,
    result: "effect1_foregroundBlur_828_3880"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter4_f_828_3880",
    x: -130.943,
    y: 376.201,
    width: 1213.48,
    height: 1000.55,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 64.7314,
    result: "effect1_foregroundBlur_828_3880"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter5_f_828_3880",
    x: -130.943,
    y: 376.201,
    width: 1213.48,
    height: 1000.55,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 64.7314,
    result: "effect1_foregroundBlur_828_3880"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter6_f_828_3880",
    x: -130.943,
    y: 376.201,
    width: 1213.48,
    height: 1000.55,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 64.7314,
    result: "effect1_foregroundBlur_828_3880"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter7_f_828_3880",
    x: -130.943,
    y: 376.201,
    width: 1213.48,
    height: 1000.55,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 64.7314,
    result: "effect1_foregroundBlur_828_3880"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter8_f_828_3880",
    x: 60.5984,
    y: 355.911,
    width: 691.673,
    height: 719.084,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 26.4801,
    result: "effect1_foregroundBlur_828_3880"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter9_f_828_3880",
    x: 616.029,
    y: 122.489,
    width: 512.273,
    height: 613.102,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.04641,
    result: "effect1_foregroundBlur_828_3880"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter10_f_828_3880",
    x: 565.535,
    y: 107.152,
    width: 602.219,
    height: 632.636,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7.16244,
    result: "effect1_foregroundBlur_828_3880"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter11_f_828_3880",
    x: 466.984,
    y: -38.7024,
    width: 678.521,
    height: 729.391,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10.232,
    result: "effect1_foregroundBlur_828_3880"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter12_f_828_3880",
    x: 275.597,
    y: -58.5109,
    width: 1033.09,
    height: 821.037,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 27.6265,
    result: "effect1_foregroundBlur_828_3880"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter13_f_828_3880",
    x: 88.6652,
    y: -278.508,
    width: 1338.49,
    height: 1066.49,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 77.539,
    result: "effect1_foregroundBlur_828_3880"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter14_f_828_3880",
    x: 88.6652,
    y: -278.508,
    width: 1338.49,
    height: 1066.49,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 77.539,
    result: "effect1_foregroundBlur_828_3880"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter15_f_828_3880",
    x: 88.6652,
    y: -278.508,
    width: 1338.49,
    height: 1066.49,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 77.539,
    result: "effect1_foregroundBlur_828_3880"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter16_f_828_3880",
    x: 88.6652,
    y: -278.508,
    width: 1338.49,
    height: 1066.49,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 77.539,
    result: "effect1_foregroundBlur_828_3880"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter17_f_828_3880",
    x: 418.706,
    y: 15.1609,
    width: 779.114,
    height: 756.69,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 31.7194,
    result: "effect1_foregroundBlur_828_3880"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_828_3880",
    x1: -150.335,
    y1: 1012.56,
    x2: 1078.32,
    y2: 779.64,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C4C4C4",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.430547,
    stopColor: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.498519,
    stopColor: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C4C4C4",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_828_3880",
    x1: 335.288,
    y1: 435.04,
    x2: 561.249,
    y2: 1019.68,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C4C4C4",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_828_3880",
    x1: 1342.15,
    y1: 112.573,
    x2: 229.096,
    y2: 486.891,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C4C4C4",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.430547,
    stopColor: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.498519,
    stopColor: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C4C4C4",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_828_3880",
    x1: 1057.47,
    y1: 822.864,
    x2: 774.377,
    y2: 51.4938,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C4C4C4",
    stopOpacity: 0
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackgroundLanding);
export default __webpack_public_path__ + "static/media/background-landing.e271981e84ab31edff24dde7f92811e1.svg";
export { ForwardRef as ReactComponent };